/* eslint-disable jsx-a11y/label-has-associated-control */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import copy from 'copy-to-clipboard';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { z } from 'zod';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, putAsync, reactURL } from '../../../components/helper/axiosHelper';

const EPUserProfile = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  //const { id } = useParams();
  const location = useLocation();
  const { id } = location.state || {};
  const [epUserApiData, setEpUserAPIData] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmNewPassword] = useState('');
  const [link, setLink] = useState('');
  const [file, setFile] = useState(null);
  const [formerror, setFormerror] = useState({});
  const [values, setValues] = useState({
    link: null,
  });
  const [epUserID, setEpUserID] = useState(null);

  const { t } = useTranslation();
  const token = localStorage.getItem('token');

  const user = z.object({
    newPassword: z
      .string()
      .min(8, 'Must be 8 or more characters long')
      .refine((value) => /[0-9]/.test(value), 'Must contain at least one number')
      .refine((value) => /[a-z]/.test(value), 'Must contain at least one lowercase letter')
      .refine((value) => /[A-Z]/.test(value), 'Must contain at least one uppercase letter'),
    confirmPassword: z.string().refine((value) => value === newPassword, 'Passwords must match', true),
  });

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      getUserData();
    }
    //displayUsername();
  }, [epUserID]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isLogin = () => {
    if (localStorage.getItem('token')) return true;
  };

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getUserData = async () => {
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        setUsername(result?.userName);
        setEmail(result?.email);
        setLink(result?.doc);
        setEpUserAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const bodyUpdate = {
    email: email,
    password: oldPassword,
    newPassword: newPassword,
    confirmPassword: confirmPassword,
  };

  const changePassword = () => {
    const parseuser = user.safeParse(bodyUpdate);
    if (!parseuser.success) {
      const error = parseuser.error;
      let newerror = {};
      for (const issue of error.issues) {
        newerror = { ...newerror, [issue.path]: issue.message };
      }
      return setFormerror(newerror);
    } else {
      alert('Are You Sure?');
      putAsync('EP_UserAuthentication/EP_User_PasswordChange', bodyUpdate)
        .then((response) => {
          const result = response?.data[0];
          if (result === 'Password SuccessFully Changes.') {
            toast.success(`${t('Successfully changed password')}`);
            setNewPassword('');
            setOldPassword('');
            setConfirmNewPassword('');
          } else {
            toast.error(t('Please enter correct current password'));
          }
        })
        .catch((error) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const handleCopy = async () => {
    try {
      await getAsync(`EP_UserAuthentication/EPUserByID/`, { id: epUserID }, axiosConfig).then((response) => {
        const result = response?.data[0];
        if (
          result?.epUserID === undefined ||
          result?.epUserID === null ||
          result?.epUserID === 0 ||
          result?.profileLink === undefined ||
          result?.profileLink === null ||
          result?.profileLink === ''
        ) {
          toast.warning(`${t('Failed to copy refferal link data not found')}`);
        } else {
          // const epUserProfile = `${reactURL}/PublicProfile/` + result?.profileLink + '/' + result?.epUserID +'/'+ 1;
          const epUserProfile = `${reactURL}/PublicProfile/` + result?.profileLink + '/' + 1;

          copy(epUserProfile);
          toast.success(`${t('Link copy Successfully')}`);
        }
      });
    } catch (error) {
      console.error('Error fetching record:', error);
    }
  };

  const showPreview = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setValues({
          ...values,
          imageFile,
          imageSrc: x.target.result,
        });
        const base64 = x.target.result.split(',').splice(1, 1)[0];
        setLink(base64);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setValues({
        ...values,
        imageFile: null,
        //imageSrc: defaultImgSrc
      });
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        setLink(baseURL.split(',')[1]);
        resolve(baseURL);
      };
    });
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    getBase64(selectedFile)
      .then((result) => {
        selectedFile['base64'] = result;
        //setLink(result);
        setFile(selectedFile);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updatebody = {
    EPUserID: epUserID,
    link,
    file,
    // UserName,
    // FullName,
    // Email,
    // Mobile: '',
    // CountryID: 0,
    // EmiratesID,
  };

  const Updateuser = async (e) => {
    e.preventDefault();
    await putAsync('EP_UserAuthentication/UpdateEPUser', updatebody, { id: epUserID }, 'multipart/form-data')
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('SuccessUpdated')}`);
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  return (
    <>
      <div className="container-fluid pb-96 sm:40">
        <div className="row pt-5 justify-center">
          <div className="col-lg-11 pt-5">
            {isLogin() ? (
              <>
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen" style={{ textAlign: 'center' }}>
                  {t('User Profile')}
                </h3>

                <div className="container-fluid">
                  <div className="row justify-center">
                    <div className="w-full  max-w-sm my-5 bg-white border-1 text-center border-green-200 rounded-2xl shadow ">
                      <div className="flex">
                        <Link to="/user/logs">
                          <button className=" text-white bg-customgreen ms-3 my-10 hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1">
                            {t('UserLogs')}
                          </button>
                        </Link>
                        <button
                          className=" text-white bg-customgreen ms-3 my-10 hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                          onClick={() => handleCopy(id)}
                        >
                          <LinkOutlinedIcon />
                          {t('ShareProfile')}
                        </button>
                      </div>
                      {/* <h1 className="mb-3 text-lg font-medium text-center">{t('welcome_message')}</h1> */}
                      <div className="flex flex-col items-center pb-10">
                        <img
                          className="w-24 h-24 mb-3 rounded-full shadow-lg"
                          src={
                            link
                              ? `data:image/jpeg;base64,${link}`
                              : 'https://media.istockphoto.com/id/1495088043/vector/user-profile-icon-avatar-or-person-icon-profile-picture-portrait-symbol-default-portrait.jpg?s=612x612&w=is&k=20&c=XmEKmysBRbA1o6zWBHLRaX2j_nrYVvdVZjuXPBLuOOo='
                          }
                          alt="userProfile.png"
                        />
                        <div className="flex mt-4 md:mt-6">
                          <input
                            className=" text-white bg-customgreen ms-0 my-10 hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5  text-center me-1"
                            // applyErrorClass('imageSrc')
                            name="link"
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            onChange={(showPreview, handleFileInputChange)}
                            id="image-uploader"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <div className="row">
                  <div className="col-lg-6">
                    <label>{t('User Name')}</label>
                    <input
                      type="text"
                      name="username"
                      disabled
                      className="bg-gray-100  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                      value={username}
                      minLength="1"
                      maxLength="50"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>
                        {t('Email')}
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={epUserApiData?.email}
                        type="text"
                        disabled
                        className=" bg-gray-100 border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                        minLength="1"
                        maxLength="50"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>
                        {t('Full Name')} <span className="errmsg">*</span>
                      </label>
                      <input
                        value={epUserApiData?.fullName}
                        disabled
                        type="text"
                        className=" bg-gray-100 border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                        minLength="1"
                        maxLength="50"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>
                        {t('Mobile')}
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={epUserApiData?.mobile}
                        disabled
                        type="tel"
                        className="bg-gray-100  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                        minLength="1"
                        maxLength="50"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>
                        {t('Country')} <span className="errmsg">*</span>
                      </label>
                      <input
                        value={epUserApiData?.countryName}
                        type="text"
                        disabled
                        className="bg-gray-100  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                      />
                    </div>
                  </div>
                  {epUserApiData[0]?.countryID === epUserApiData[0]?.countryID && (
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          {t('Emirates')}
                          <span className="errmsg">*</span>
                        </label>
                        <input
                          value={epUserApiData?.emiratesName}
                          type="text"
                          disabled
                          className="bg-gray-100  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-lg-6 my-5">
                  <button
                    className=" text-white bg-customgreen ms-3  hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                    style={{ float: 'right' }}
                    onClick={Updateuser}
                  >
                    {t('Update')}
                  </button>
                </div>
                <br />
                <br />
                <br />
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <Typography style={{ fontWeight: '600' }}>{t('Change Password')}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography></Typography>
                    <div className="row">
                      <div className="col-lg-4">
                        <label>{t('Old Password')}</label>
                        <input
                          className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          type="password"
                          placeholder="Old Password"
                          minLength="8"
                          value={oldPassword}
                          maxLength="50"
                          onChange={(e) => setOldPassword(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label>{t('New Password')}</label>
                        <input
                          //
                          type={'password'}
                          placeholder="New Password"
                          className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          minLength="8"
                          maxLength="50"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        {formerror.newPassword && <p className="text-red-700">{formerror.newPassword}</p>}
                        {/* <button
                          type="button"
                          className={`eye-button ${isActive ? 'left-1' : 'right-1'}`}
                          style={{
                            backgroundColor: 'transparent',
                            border: '0',
                            position: 'absolute',

                            top: '50%',
                            transform: 'translateY(-50%)',
                          }}
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </button> */}
                      </div>
                      <div className="col-lg-4">
                        <label>{t('Confirm Password')}</label>
                        <input
                          type="password"
                          placeholder={t('Confirm Password')}
                          className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          minLength="8"
                          maxLength="50"
                          value={confirmPassword}
                          onChange={(e) => setConfirmNewPassword(e.target.value)}
                        />
                        <br />
                        {formerror.confirmPassword && <p className="text-red-700">{formerror.confirmPassword}</p>}
                      </div>

                      <div className="col-lg-6 pt-5">
                        <button
                          className=" text-white bg-customgreen ms-3  hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                          style={{ float: 'right' }}
                          onClick={changePassword}
                        >
                          {t('Change')}
                        </button>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </>
            ) : (
              <>{t('Not Authorized!')}</>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EPUserProfile;
